import { trackEvent as _trackEvent } from '@pushwoosh/kit-helpers';

import { getCookie } from './cookies';

interface PWTrackEvent {
  name: string;
  properties?: Record<string, unknown>;
}

export function trackEvent({ name, properties }: PWTrackEvent): void {
  _trackEvent({
    name,
    properties: {
      user_id: getCookie('user_id') ?? '',
      ln: navigator.language,
      ref: document.referrer,
      ...properties,
    },
  });
}
